var $404def46e9659a20$exports = {};
$404def46e9659a20$exports = {
    "maximum": `\u{6700}\u{5927}`,
    "minimum": `\u{6700}\u{5C0F}`
};


export {$404def46e9659a20$exports as default};
//# sourceMappingURL=zh-CN.module.js.map
